import type { FC } from 'react';
import { isUrl } from '../../utils/isUrl';
import { cn } from '../../utils/util';

type App = {
  id: string;
  appLogo: string;
  mobileAppName: string;
  isPublished: boolean;
};

interface AppCardProps {
  app: App;
  onClick?: () => void;
}

const AppCard: FC<AppCardProps> = ({ app, onClick }) => {
  const { appLogo, mobileAppName, isPublished } = app;
  const dummy =
    'https://cdn.dribbble.com/userupload/11926486/file/original-2d8002832f7422a2eccf148b170e5cca.png?resize=70x70';

  return (
    <div
      onClick={onClick}
      className="flex flex-col w-[130px] gap-[5px] justify-center items-center cursor-pointer transition-transform duration-300 hover:scale-110"
    >
      <div className="w-[6rem] h-[6rem] border border-[#E3E8EF] rounded-[10px] top-[0px]  duration-200">
        <img src={isUrl(appLogo) ? appLogo : dummy} alt={mobileAppName} className="w-full h-full rounded-[10px]" />
      </div>

      <div className={`text-center items-center text-[10px] px-1 flex flex-row justify-between content-center w-[5rem] rounded-[10px] `}>
        <div className={`w-full text-center font-bold ${isPublished ? "text-green-600" : "text-red-600"}`}>{isPublished ? "Yayında" : "Pasif"}</div>
      </div>

      <div className={`text-[12px] w-[5rem] truncate text-center content-center rounded-[10px] `}>
        {mobileAppName}
      </div>
    </div>
  );
};
export default AppCard;
